import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class FilterIcon extends Component {
    render() {
        return (
            <svg {...this.props} height="10" viewBox="0 0 10 10" width="10" xmlns="http://www.w3.org/2000/svg"><path d="M10 2L6.503 5v3.012L3.497 10V5S-.001 2.043 0 2V.211C0 .095.115 0 .256 0h9.488c.068 0 .133.022.181.062.048.04.075.093.075.15V2z" fillRule="evenodd"/></svg>
        )
    }
}

export default withCssClassName(FilterIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/filter-icon.js